import { FiX } from "react-icons/fi";
import { ReactNode } from "react";

interface BackButtonProps {
  onClick?: () => void;
  onBack?: () => void;
  title?: string;
  className?: string;
  background?: string;
  icon?: ReactNode;
}

function BackButton({
  onClick,
  onBack,
  title,
  className,
  background,
  icon,
}: BackButtonProps) {
  return (
    <button
      type="button"
      className={
        "ef-btn ef-gradient-surface flex justify-center py-4 px-4 font-bold italic text-white " +
        (className ?? "")
      }
      style={{
        background: background ?? undefined,
      }}
      onClick={() => {
        if (onClick) {
          onClick();
        } else if (onBack) {
          onBack();
        }
      }}
    >
      <div className="flex items-center gap-2">
        {icon ?? <FiX size={20} />}
        {title ?? ""}
      </div>
    </button>
  );
}

export default BackButton;
